'use strict';

window.console || (window.console = {
	log: function log() {}
});
var EPS = window.EPS || null;
var cssua = window.cssua || null;

(function ($) {
	var htmlHasClass = function htmlHasClass(_class) {
		return $('html').hasClass(_class);
	};
	var siteName = 'eps';
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-move';
	var slideSpeed = '400';

	EPS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (var _i = 0; _i < includeClassLen; _i++) {
				var path = includeClass[_i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (var _i2 = 0; _i2 < ajaxLen; _i2++) {
					ajaxArrayList[_i2] = $.ajax({
						type: 'GET',
						url: ajaxArray[_i2] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					if (args[1] === 'success') {
						// includeが1個だけの場合
						var position = $(args[0]).filter(':first').attr('class').split(' ');
						for (var j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(args[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					} else {
						for (var _i3 = 0; _i3 < args.length; _i3++) {
							var result = args[_i3];
							var _position = $(result[0]).filter(':first').attr('class').split(' ');

							for (var _j = 0; _j < _position.length; _j++) {
								if (_position[_j].match(regExp)) {
									_position = _position[_j];
									break;
								}
							}
							$('.' + _position).html(result[0]).children().unwrap();

							console.log('Succeeded to read the include file!:', _position);
						}
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle: function nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', function () {
				$(this).toggleClass(a);
				$(this).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on('click', function (event) {
				if (/#/.test(event.currentTarget.href)) {
					var speed = 1200;
					scrollToObject(event, speed);
					return false;
				}
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.currentTarget.href.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					// /epsstyle/ ディレクトリの場合は異なる高さ設定を使用
					if (location.pathname.indexOf('/epsstyle/') === 0) {
						// epsstyleのヘッダー高さを取得
						var epsstyleHeader = document.querySelector('.epsstyle-header');
						if (epsstyleHeader) {
							pos -= epsstyleHeader.offsetHeight;
						} else {
							// epsstyleヘッダーが見つからない場合のフォールバック
							if (EPS.va.window.width < EPS.va.device.sp) {
								pos -= 60;
							} else {
								pos -= 100;
							}
						}
					} else {
						// 通常の調整（既存の処理）
						if (EPS.va.window.width < EPS.va.device.sp) {
							pos -= 60;
						} else {
							pos -= 120;
						}
					}
				}

				// $('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
				// lazyloadとの併用のための記述
				$.when($('html, body').animate({
					scrollTop: pos
				}, _speed, 'easeOutExpo')
				// _self.preventDefault(),
				).done(function () {
					if (hash !== '#pagetop') {
						var diff = $(hash).offset().top;
						// /epsstyle/ ディレクトリの場合は異なる高さ設定を使用
						if (location.pathname.indexOf('/epsstyle/') === 0) {
							// epsstyleのヘッダー高さを取得
							var _epsstyleHeader = document.querySelector('.epsstyle-header');
							if (_epsstyleHeader) {
								diff -= _epsstyleHeader.offsetHeight;
							} else {
								// epsstyleヘッダーが見つからない場合のフォールバック
								if (EPS.va.window.width < EPS.va.device.sp) {
									diff -= 60;
								} else {
									diff -= 100;
								}
							}
						} else {
							// 通常の調整（既存の処理）
							if (EPS.va.window.width < EPS.va.device.sp) {
								diff -= 60;
							} else {
								diff -= 120;
							}
						}
						if (diff !== pos) {
							$('html, body').animate({
								scrollTop: diff
							}, 10, 'easeOutExpo');
						}
					}
				});
			}
		},
		headerMenu: function headerMenu() {
			var d = 'is-down';
			var $hamburger = $('.header-hamburger');
			var $nav = $('.header-nav');
			var $search = $('.header-search');
			var $searchBtn = $('.header-btns-search');
			var $overlay = $('.header-search-overlay');
			var $close = $('.header-search-close');
			var $headerNavItem = $('.header-nav-item');
			var $siteSearch = $('.header-nav-siteSearch');

			var scrollTopNow = void 0;
			var flag = false;
			$hamburger.on('click', function (e) {
				var $this = $(e.currentTarget);
				$this.toggleClass(a);
				$nav.toggleClass(a);
				$('.header').toggleClass(a);
				$('.header-inner').toggleClass('is-menuopen');

				if (!flag) {
					scrollTopNow = document.body.scrollTop + document.documentElement.scrollTop;
					$('.container').css({
						position: 'fixed',
						width: '100%',
						top: -1 * scrollTopNow,
						left: 0
					});
					flag = true;
				} else {
					$('.container').css({
						position: 'static'
					});

					$(window).scrollTop(scrollTopNow);
					flag = false;
				}
			});

			// リサイズイベントを追加
			$(window).on('resize', function () {
				// ウィンドウ幅の更新
				EPS.va.window.width = $(window).width();
				EPS.va.window.height = $(window).height();

				// 1310px以上の場合のみ処理を実行
				if (EPS.va.window.width >= 1310) {
					// ハンバーガーメニューがアクティブな場合の処理
					if ($hamburger.hasClass(a)) {
						$hamburger.removeClass(a);
						$nav.removeClass(a);
						$('.header').removeClass(a);
						$('.header-inner').removeClass('is-menuopen');
						$('.container').css({
							position: 'static'
						});
						$('.header-nav-item-dropdown').removeAttr('style');

						$(window).scrollTop(scrollTopNow);
						flag = false;
					}
				}
			});

			// サイト内検索（PCのみ）
			if (EPS.va.window.width > 1024) {
				var moveFlg = function moveFlg() {
					if ($('.header').hasClass('is-move')) {
						return true;
					}
				};
				$('.js-header-siteSearch').on('click', function () {
					var headerFlg = moveFlg();
					fixedOnContainer();
					$overlay.addClass(a);
					$siteSearch.addClass(a);
					$close.addClass(a);
					setTimeout(function () {
						$overlay.addClass(v);
						$siteSearch.addClass(v);
						$close.addClass(v);
						if (headerFlg === true) {
							$('.header').addClass('is-move');
						}
					});
				});
				$overlay.on('click', function () {
					$siteSearch.removeClass(v);
					$close.removeClass(v);
					$overlay.removeClass(v);
					setTimeout(function () {
						$siteSearch.removeClass(a);
						$close.removeClass(a);
						$overlay.removeClass(a);
					}, 400);
					fixedOffContainer();
				});
				$close.on('click', function () {
					$siteSearch.removeClass(v);
					$close.removeClass(v);
					$overlay.removeClass(v);
					setTimeout(function () {
						$siteSearch.removeClass(a);
						$close.removeClass(a);
						$overlay.removeClass(a);
					}, 400);
					fixedOffContainer();
				});
			}

			var fixedOnContainer = function fixedOnContainer() {
				scrollTopNow = $(window).scrollTop();
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};
			var fixedOffContainer = function fixedOffContainer() {
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
			};

			$headerNavItem.on('click', function (e) {
				var $this = $(e.currentTarget);
				$this.find('.header-nav-item-dropdown').slideToggle();
			});
		},
		headerScroll: function headerScroll() {
			$(window).scroll(function () {
				var headerHeight = $('.header').innerHeight();
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollTop > headerHeight) {
					$('.header').addClass(f);
				} else if ($('.header').hasClass(f)) {
					$('.header').removeClass(f);
				}
			});
		},
		headerNav: function headerNav() {
			if (EPS.va.window.width < EPS.va.device.sp) {
				$('.js-headerNav').click(function () {
					$(this).next('.js-headerNav-in').slideToggle();
				});
			}
		},
		footerNav: function footerNav() {
			var _this2 = this;

			// 初期化
			this.setupFooterNav();

			// リサイズイベントの追加
			$(window).on('resize', function () {
				// ウィンドウ幅を更新
				EPS.va.window.width = $(window).width();
				EPS.va.window.height = $(window).height();

				// フッターナビゲーションのセットアップを再実行
				_this2.setupFooterNav();
			});
		},


		// フッターナビゲーションのセットアップ処理
		setupFooterNav: function setupFooterNav() {
			if (EPS.va.window.width <= EPS.va.device.desktop) {
				// すでにイベントが設定されている場合は一度解除して再設定
				$('.js-footerNav').off('click');
				$('.js-footerNav').on('click', function () {
					$(this).next('.js-footerNav-in').slideToggle();
				});
			} else {
				// PCサイズの場合はクリックイベントを削除
				$('.js-footerNav').off('click');
				// 閉じられているメニューがあれば開く
				$('.js-footerNav-in').each(function () {
					if (!$(this).is(':visible')) {
						$(this).show();
					}
				});
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');
			var $footer = $('.footer');

			if ($footer.length === 0) return;

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var footerPos = $footer.offset().top;
				var thisScroll = $this.scrollTop();
				var windowHeight = $this.height();

				if (thisScroll > 150 && thisScroll + windowHeight < footerPos) {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
			});
		},
		modal: function modal() {
			$('.mod-modal').on('click', function (e) {
				var HTML = '<div class="mod-modal-overlay">';
				HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><span></span></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
				$('body').append(HTML);
				var $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		epsWayModal: function epsWayModal() {
			$('.about-epsway-modal').on('click', function (e) {
				var HTML = '<div class="about-epsway-modal-overlay">';
				HTML += '<div class="mod-auto">' + '<div class="about-epsway-modal-content">' + '<h2 class="about-epsway-modal-content-ttl">トップメッセージ</h2>' + '<div class="about-epsway-modal-content-in">' + '<h3 class="about-epsway-modal-content-subttl">EPSグループは2021年5月、創業30周年を迎えました。</h3>' + '<div class="pure-g space-u-30 pt50">' + '<div class="pure-u-2-3 pure-u-lg-1 space-u-30-child">' + '<p class="fs_16 fs_md_14">医療統計を基礎とするシステム会社としてスタートした私たちは、医薬品開発の厳密化・複雑化、市場の構造変化にともなう顧客のニーズに応える形で、CRO、SMOからCSOへと医薬品のライフサイクルに合わせたアウトソーシングサービスへと発展してきました。またそのサービス範囲は、医薬品を医療機器や診断薬、健康食品へとヘルスケア産業全体に業域を広げ、さらに中国を中心に、医薬品プロダクトビジネスも展開するようになりました。</p>' + '<p class="mt50 fs_16 fs_md_14">そしていま、バーチャル治験、ビッグデータの活用、AIによる医療情報の提供などDX化の加速にともない、私たちを取り巻くビジネス環境は大きな変化を遂げつつあります。また、創薬技術のパラダイムシフトにともない、本邦に基盤を持たない欧米やアジアのアカデミアやバイオベンチャーから医薬品や関連製品の開発、製造から流通までのソリューションが私たちに期待されるようになっています。</p>' + '<p class="mt50 fs_16 fs_md_14">私たちが目指すのは従来の枠を超えたヘルスケア産業全体のソリューションカンパニーです。過去から今、そしてこの先も基本理念の「価値あるソリューションの創出を通じて、健康産業の発展に貢献します」とともに、ベンチャースピリットを忘れることなく、みなさまとともに歩み続けていきたいと思います。</p>' + '<p class="mt40 fs_16 fs_md_14 fw_bold ta_right">EPSホールディングス株式会社 代表取締役</p>' + '<figure class="mt10 ta_right"><img src="/images/about/epsway/modal_name.webp" class="height-auto" width="112" height="43"></figure>' + '</div>' + '<div class="pure-u-1-3 pure-u-lg-1 space-u-30-child">' + '<figure class="ta_center" data-view="pc tablet"><img src="/images/about/epsway/modal.webp" class="mod-borderRadius"></figure>' + '</div>' + '</div>' + '<span class="about-epsway-modal-closeBtn"><span></span></span>' + '</div>' + '</div>' + '</div>' + '<div class="about-epsway-modal-closeArea"></div>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
				$('body').append(HTML);
				var $overlay = $('.about-epsway-modal-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.about-epsway-modal-closeArea, .about-epsway-modal-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		epsWayModalEn: function epsWayModalEn() {
			$('.about-epsway-modal-en').on('click', function (e) {
				var HTML = '<div class="about-epsway-modal-overlay">';
				HTML += '<div class="mod-auto">' + '<div class="about-epsway-modal-content">' + '<h2 class="about-epsway-modal-content-ttl">Top Message</h2>' + '<div class="about-epsway-modal-content-in">' + '<h3 class="about-epsway-modal-content-subttl">The EPS Group Celebrated its 30th<br>Anniversary in May 2021</h3>' + '<div class="pure-g space-u-30 pt50">' + '<div class="pure-u-2-3 pure-u-lg-1 space-u-30-child">' + '<p class="fs_16 fs_md_14">From our beginnings as a systems company built on medical statistics, the EPS Group has responded to customer needs amid structural changes in the market and increasingly rigorous and complex drug development. We have done so by evolving from a contract research organization (CRO) and site management organization (SMO) to a contract sales organization (CSO), and by developing outsourcing services that match the lifecycle of pharmaceuticals. The scope of our services has broadened from pharmaceuticals to medical devices, diagnostic drugs, and health foods to the healthcare industry as a whole. We have also built up the pharmaceutical products business with a focus on China.</p>' + '<p class="mt50 fs_16 fs_md_14">The business environment is now undergoing major changes in step with accelerating digital transformation (DX), such as virtual clinical trials, Big Data, and the use of AI for providing medical information. As a result of the paradigm shift to drug discovery technologies, academic institutions and bio-ventures in the West and in Asia without a base in Japan now look to us for solutions ranging from developing and manufacturing to distributing pharmaceuticals and related products.</p>' + '<p class="mt50 fs_16 fs_md_14">We aim to go beyond the conventional framework to become a solutions company for the entire healthcare industry. From the past to the present and into the future, we will continue to move forward together with our clients without losing the entrepreneurial spirit and the corporate philosophy of contributing to the advancement of the healthcare industry by providing high-value-added solutions.</p>' + '<p class="mt40 fs_16 fs_md_14 fw_bold ta_right">Hao YAN<br>Representative Director<br>EPS Holdings, Inc.</p>' + '</div>' + '<div class="pure-u-1-3 pure-u-lg-1 space-u-30-child">' + '<figure class="ta_center" data-view="pc tablet"><img src="/images/about/epsway/modal.webp" class="mod-borderRadius"></figure>' + '</div>' + '</div>' + '<span class="about-epsway-modal-closeBtn"><span></span></span>' + '</div>' + '</div>' + '</div>' + '<div class="about-epsway-modal-closeArea"></div>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
				$('body').append(HTML);
				var $overlay = $('.about-epsway-modal-overlay');
				$overlay.addClass(a);
				setTimeout(function () {
					$overlay.addClass(v);
					$('.about-epsway-modal-closeArea, .about-epsway-modal-closeBtn').on('click', function () {
						$overlay.removeClass(v);
						setTimeout(function () {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		lazyload: function lazyload() {
			if ($('.js-lazy-img').length) {
				$('.js-lazy-img').lazyload();
			}
		},
		share: function share() {
			if ($('.mod-share').length) {
				var pageUrl = document.URL;
				var shareUrl = "";
				var sharePagetitle = encodeURIComponent(document.title);
				// facebook
				if ($('.mod-share ._facebook').length) {
					shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
					$('.mod-share ._facebook').attr('href', shareUrl);
				}
				// twitter
				if ($('.mod-share ._twitter').length) {
					shareUrl = 'https://twitter.com/share?text=' + sharePagetitle + '&url=' + pageUrl;
					$('.mod-share ._twitter').attr('href', shareUrl);
				}
				// line
				if ($('.mod-share ._line').length) {
					shareUrl = 'https://social-plugins.line.me/lineit/share?url=' + pageUrl;
					$('.mod-share ._line').attr('href', shareUrl);
				}
				// linkedin
				if ($('.mod-share ._linkedin').length) {
					shareUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + pageUrl;
					$('.mod-share ._linkedin').attr('href', shareUrl);
				}
			}
		},
		siteSearch: function siteSearch() {
			$('.js-siteSearch-submit').on('click', function (e) {
				if ($(e.currentTarget).prev('.js-siteSearch-input').val()) {
					window.open('https://www.google.co.jp/search?sitesearch=www.eps-holdings.co.jp&q=' + encodeURIComponent($(e.currentTarget).prev('.js-siteSearch-input').val()), '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
				} else {
					window.open('https://www.google.co.jp/search?sitesearch=www.eps-holdings.co.jp', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
				}
			});
			$('.js-siteSearch-input').on('keydown', function (e) {
				if (e.keyCode === 13) {
					if ($(e.currentTarget).val()) {
						window.open('https://www.google.co.jp/search?sitesearch=www.eps-holdings.co.jp&q=' + encodeURIComponent($(e.currentTarget).val()), '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
					} else {
						window.open('https://www.google.co.jp/search?sitesearch=www.eps-holdings.co.jp', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
					}
				}
			});
		},
		fileSizeEx: function fileSizeEx() {
			var setFileSize = function setFileSize(className) {
				console.log(className);
				if ($(className).length) {
					$(className).each(function () {
						$(this).text('' + bytesToSize($(this).text()) + '');
					});
				}
				function bytesToSize(bytes) {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if (bytes === 0) {
						return 'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if (i === 0) {
						return bytes + ' ' + sizes[i];
					}
					return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
				}
			};
			setFileSize('.rt_cf_n_cf_n_attachment_file_size');
		},
		sideNav: function sideNav() {
			if ($('.js-sideNav').length) {
				var directory = location.pathname.split('/')[1];
				if (location.pathname.split('/')[1] === 'english') {
					directory = location.pathname.split('/')[2];
				}
				// li並び順設定・該当のリンクリスト表示
				for (var _i4 = 0; _i4 < $('.js-sideNav > li').length; _i4++) {
					if (directory === $('.js-sideNav > li').eq(_i4).data('directory')) {
						$('.js-sideNav > li').eq(_i4).addClass(a);
					}
				}
				// リンクのカレント
				for (i = 0; i < $('.mod-column-nav-sideMenu-link02').length; i++) {
					if (location.pathname.replace('index.html', '') === $('.mod-column-nav-sideMenu-link02').eq(i).attr('href')) {
						$('.mod-column-nav-sideMenu-link02').eq(i).addClass('is-current');
						$('.mod-column-nav-sideMenu-link02').eq(i).next('._list03').css('display', 'block');
					}
				}
				for (i = 0; i < $('.mod-column-nav-sideMenu-link03').length; i++) {
					if (location.pathname.replace('index.html', '') === $('.mod-column-nav-sideMenu-link03').eq(i).attr('href')) {
						$('.mod-column-nav-sideMenu-link03').eq(i).addClass('is-current');
						$('.mod-column-nav-sideMenu-link03').eq(i).parents('._list03').css('display', 'block');
					}
				}
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.headerMenu();
			_this.headerScroll();
			_this.headerNav();
			_this.footerNav();
			_this.pageTop();
			_this.modal();
			_this.epsWayModal();
			_this.epsWayModalEn();
			_this.lazyload();
			_this.share();
			_this.siteSearch();
			_this.fileSizeEx();
			_this.sideNav();
			svg4everybody();
		}
	};

	$(function () {
		return EPS.localDecision() ? EPS.localLoading() : EPS.loadDelayScript();
	});
})(window.jQuery);
$(window).on('load', function () {
	var easeScrollHash = function easeScrollHash() {
		if (location.hash) {
			$('html, body').css('display', 'none');
			setTimeout(function () {
				$('html, body').css('display', 'block');
				var _hash = '#' + location.hash.split('#')[1];
				var pos = $(_hash).offset().top;
				if ($(window).width() < 1024) {
					pos -= 60;
				} else {
					pos -= 120;
				}
				// $('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
				// lazyloadとの併用のための記述
				$.when($('html, body').animate({
					scrollTop: pos
				}, 1200, 'easeOutExpo')
				// _self.preventDefault(),
				).done(function () {
					var diff = $(_hash).offset().top;
					if ($(window).width() < 1024) {
						// /epsstyle/ ディレクトリの場合は異なる高さ設定を使用
						if (location.pathname.indexOf('/epsstyle/') === 0) {
							// epsstyleのヘッダー高さを取得
							var epsstyleHeader = document.querySelector('.epsstyle-header');
							if (epsstyleHeader) {
								diff -= epsstyleHeader.offsetHeight;
							} else {
								// epsstyleヘッダーが見つからない場合のフォールバック
								if (EPS.va.window.width < EPS.va.device.sp) {
									diff -= 60;
								} else {
									diff -= 100;
								}
							}
						} else {
							// 通常の調整（既存の処理）
							if (EPS.va.window.width < EPS.va.device.sp) {
								diff -= 60;
							} else {
								diff -= 120;
							}
						}
					}
					if (diff === pos) {
						$('html, body').animate({
							scrollTop: diff
						}, 10, 'easeOutExpo');
					}
				});
			}, 100);
		}
	};
	easeScrollHash();
});